import {
  Facebook,
  Instagram,
  Telegram,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Box sx={{ background: "rgba(0, 35, 70, 1)", textAlign: "center" }}>
      <Box py={7}>
        <Typography
          sx={{
            fontSize: { md: "26.77px", xs: "18px" },
            fontFamily: "Zen Dots",
            fontWeight: "400",
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          Don't miss out, Stay updated
        </Typography>
        <Stack sx={{ py: 3 }}>
          <form>
            <TextField
              size="small"
              id="email"
              placeholder="Enter Your Email"
              InputLabelProps={{
                style: { color: "white" },
              }}
              InputProps={{
                sx: {
                  background: "#193958",
                  color: "white",
                  borderRadius: "25px",
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "none",

                    color: "white",
                  },
                  "&:hover": {
                    ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "none",
                      borderRadius: "25px",
                      color: "white",
                    },
                  },
                },
              }}
              sx={{
                width: { xs: "90%", sm: "70%", md: "36%" },
                color: "white !important",
                "& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
                  borderRadius: "36px",
                },
                ".css-x2l1vy-MuiInputBase-root-MuiOutlinedInput-root": {
                  color: "white",
                },
              }}
            />
            <Button
              sx={{
                ml: -18,

                px: 5,
                py: 1,
                color: "#FFFFFF",
                borderRadius: 7,
                background:
                  "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
              }}
            >
              Subscribe
            </Button>
          </form>
        </Stack>
        <Typography
          sx={{
            fontSize: "11.16px",
            fontFamily: "Inter",
            fontWeight: "400",
            color: "rgba(246, 246, 246, 1)",
            textAlign: "center",
          }}
        >
          Don’t hesitate to subscribe to latest news about ICo markets as well
          as crucial financial <br /> knowledge to become successful investors
          globally
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            pt: 3,
            color: "white",
          }}
        >
          <Twitter />
          <Facebook />
          <Instagram />
          <Telegram />
          <YouTube />
        </Box>
      </Box>
      <Box sx={{ pt: 1, borderTop: "1px solid rgba(26, 100, 205, 1)" }}>
        <Typography
          sx={{
            fontSize: "10.41px",
            fontFamily: "Inter",
            fontWeight: "400",
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          © 2022. All rights reserved by Avitex
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
